import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { subscribeToNewsletter } from '../../services/newsletterApi';

const NewsletterCTA = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    if (!email.trim()) {
      setError(
        t('home.newsletter.errorRequired') || 'Please enter your email.'
      );
      return;
    }

    setLoading(true);
    try {
      await subscribeToNewsletter({ email });
      setMessage(
        t('home.newsletter.success') ||
          'You have been subscribed to the newsletter.'
      );
      setEmail('');
    } catch (err) {
      const msg = err.message || 'Subscription failed. Please try again.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="px-5 lg:px-8 xl:px-8 py-[60px] sm:py-24 lg:py-[172px] bg-black text-white">
      <div className="max-w-[960px] mx-auto text-center">
        <h3 className="libre-baskerville text-[32px] sm:text-[45px] text-center leading-[40px] sm:leading-[63px] max-w-[500px] mx-auto w-full">
          {t('home.newsletter.title')}
        </h3>

        {/* Combined input pill with inner button */}
        <form
          className="mt-6 sm:mt-[70px] flex justify-center"
          onSubmit={handleSubmit}
        >
          <div className="w-full max-w-[600px] relative flex items-center border border-[#E5E5E5] rounded-[10px] overflow-hidden bg-[#F9F9F9]">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t('home.newsletter.emailPlaceholder')}
              className="flex-1 h-[54px] bg-[#E5E5E5] px-4 font-normal text-[16px] leading-[22px] text-black placeholder-[#797979] outline-none"
            />
            <button
              type="submit"
              disabled={loading}
              className="py-2 absolute top-1 bottom-1 right-1 px-[35px] bg-black text-[15px] leading-[16px] text-white rounded-[9px] transition-colors disabled:opacity-60"
            >
              {loading
                ? t('home.newsletter.loading') || 'Subscribing...'
                : t('home.newsletter.cta')}
            </button>
          </div>
        </form>

        {error && <p className="mt-3 text-sm text-red-400">{error}</p>}
        {message && !error && (
          <p className="mt-3 text-sm text-green-400">{message}</p>
        )}

        {/* Avatar group */}
        <div className="mt-6 sm:mt-[30px] flex items-center justify-center gap-5">
          <div className="flex -space-x-3">
            <img
              src="/assets/placeholder.svg"
              alt="member"
              className="w-[50px] h-[50px] rounded-full z-30 "
            />
            <img
              src="/assets/placeholder.svg"
              alt="member"
              className="w-[50px] h-[50px] rounded-full z-20 "
            />
            <img
              src="/assets/placeholder.svg"
              alt="member"
              className="w-[50px] h-[50px] rounded-full z-10 "
            />
            <span className="w-[50px] h-[50px] rounded-full bg-white inline-block z-0" />
          </div>
          <span className="text-[15px] sm:text-[16px] leading-[15px] font-medium tracking-[0px] text-white/80">
            {t('home.newsletter.joinText')}
          </span>
        </div>
      </div>
    </section>
  );
};

export default NewsletterCTA;
